import React, { useEffect, useState } from 'react';
import {getCSV, getSPSSVars, getPPT} from "../../../../utils/SurveyExportUtils";
import {withToastManager} from "react-toast-notifications";

function SurveyExportButtons(props) {
    const { surveyId, multipleQuestions, questionsReady } = props;
    const initialState = { exportFunction: undefined, areButtonsDisabled: false };
    const [state, setState] = useState(initialState);
    const { exportFunction, areButtonsDisabled } = state;

    const showDownloadErrorToast = () => {
        props.toastManager.add("Oops! Download failed. Please try again.", {
            appearance: 'error'
        });
    };

    useEffect(() => {
        exportFunction && exportFunction();
    },[state]);

    const onCSVClick = () => {
        const csvPromise = getCSV(surveyId);
        csvPromise.catch(showDownloadErrorToast)
                  .finally(() => {setState(initialState)});
    };

    const onSPPSClick = () => {
        const spssPromise = getSPSSVars(surveyId, multipleQuestions);
        spssPromise.catch(showDownloadErrorToast)
                   .finally(() => {setState(initialState)});
    };

    const onPPTClick = () => {
        let exportPptChartsPayloadPromise = props.createChartsPayloadPromise();
        exportPptChartsPayloadPromise.then(exportPptChartsPayload => {
            const pptPromise = getPPT(surveyId, exportPptChartsPayload);
            pptPromise.catch(showDownloadErrorToast)
                .finally(() => {setState(initialState)});
        });
    };

    return (
        <ul className={"questionaire__menuReports " + (areButtonsDisabled ? "questionaire__menuReports__loader" : "")}>
            <li className="questionaire__menuReports__item">
                <a className="questionaire__menuReports__item__csv"
                   href="#"
                   disabled={!questionsReady || areButtonsDisabled}
                   onClick={(event) => {
                       event.preventDefault();
                       setState({exportFunction: onCSVClick, areButtonsDisabled: true});
                   }}
                >
                    Export CSV
                </a>
            </li>
            <li className="questionaire__menuReports__item">
                <a className="questionaire__menuReports__item__spss"
                   href="#"
                   disabled={!questionsReady || areButtonsDisabled}
                   onClick={(event) => {
                       event.preventDefault();
                       setState({exportFunction: onSPPSClick, areButtonsDisabled: true});
                   }}
                >
                    Export SPSS Syntax
                </a>
            </li>
            {(!props.isMobile && window.bubblyWebsiteConfig.IS_EXPORT_PPT_ENABLED) &&
            <li className="questionaire__menuReports__item">
                <a className="questionaire__menuReports__item__ppt"
                   href="javascript:;"
                   disabled={!questionsReady || areButtonsDisabled}
                   onClick={(event) => {
                       event.preventDefault();
                       setState({exportFunction: onPPTClick, areButtonsDisabled: true});
                   }}
                >
                    Export PPT
                </a>
            </li>
            }
        </ul>
    )
}

export default withToastManager(SurveyExportButtons);